import React from 'react';
import MyAccountPersonalInformationCard from './MyAccountPersonalInformationCard';
import MyAccountPasswordCard from './MyAccountPasswordCard';
import MyAccountUnitsCard from './MyAccountUnitsCard';
import MyAccountPrivacyCard from './MyAccountPrivacyCard';
import * as Row from '../layout/Row';

export default function MyAccountPage(props) {
    const unitsVisible = props.units.length > 0;
    return (
        <React.Fragment>
            <Row.Container hasOuterGutter={false}>
                <div className={unitsVisible ? "column-8 column-xs-12" : ""}>
                    <MyAccountPersonalInformationCard model={props.personalInformation}
                        defaultSettingsModel={props.defaultSettings} />
                    <MyAccountPasswordCard model={props.password} />
                    <MyAccountPrivacyCard />
                </div>
                {unitsVisible && (
                    <div className="column-4 column-xs-12">
                        <MyAccountUnitsCard model={{ units: props.units }}/>
                    </div>
                )
                }
            </Row.Container>
        </React.Fragment>
    )
}

window.components.MyAccountPage = MyAccountPage